import * as React from 'react';
import {
    Button,
    createStyles,
    Grid,
    TextField,
    Theme,
    withStyles
} from '@material-ui/core';
import {API} from "aws-amplify";
import {Alert} from "@material-ui/lab";
import JsonRenderComponent from "../../../../../../utils/JsonRenderComponent";
import { LoadingSpinner } from "../../../../../../utils/LoadingSpinner";
import AcceptCarePartnerInvitationResult from "./AcceptCarePartnerInvitationResult";

const styles = ({spacing}: Theme) => createStyles({
    buttonWrapper: {
        backgroundColor: '#00cc00',
        marginTop: spacing(1),
    }
});

interface IAcceptCarePartnerInvitationState {
    errorText: string,
    errorMessage: any,
    formSubmitted: boolean,
    invitationId: string,
    inviteeCID: string,
    inviteePersonId: string
    inviterDateOfBirth: string,
    message: string,
    open: boolean,
    response: any
    resultSuccessful: boolean,
    showDropDowns: boolean,
    showLoadingSpinner: boolean;
}

class AcceptCarePartnerInvitationSection extends React.Component<any, IAcceptCarePartnerInvitationState> {
    constructor(props: any) {
        super(props);

        this.state = {
            errorMessage: '',
            errorText: '',
            formSubmitted: false,
            invitationId: '',
            inviteeCID: '',
            inviteePersonId: '',
            inviterDateOfBirth: '',
            message: '',
            open: false,
            response: '',
            resultSuccessful: false,
            showDropDowns: false,
            showLoadingSpinner: false
        };

        this.handleInvitationId = this.handleInvitationId.bind(this);
        this.handleInviteeCID = this.handleInviteeCID.bind(this);
        this.handleInviteePersonId = this.handleInviteePersonId.bind(this);
        this.handleInviterDateOfBirth = this.handleInviterDateOfBirth.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    public render() {
        return (
            <Grid item xs={12}>
                <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                    spacing={3}
                >
                    {this.state.showLoadingSpinner && <LoadingSpinner/>}
                    <Alert variant="filled" severity="warning" style={{ fontSize: '20px'}}>
                        Please log in to both your inviter and invitee accounts at least once before running this task.
                    </Alert>
                    <Grid item xs>
                        <TextField
                            style={{width: 400}}
                            label="Invitee Person Id (Required)"
                            variant="outlined"
                            value={this.state.inviteePersonId}
                            onChange={this.handleInviteePersonId}
                        />
                    </Grid>
                    <Grid item xs>
                        <TextField
                            style={{width: 400}}
                            label="Invitee Customer Id (Required)"
                            variant="outlined"
                            value={this.state.inviteeCID}
                            onChange={this.handleInviteeCID}
                        />
                    </Grid>
                    <Grid item xs>
                        <TextField
                            style={{width: 400}}
                            label="InvitationId (Required)"
                            variant="outlined"
                            value={this.state.invitationId}
                            onChange={this.handleInvitationId}
                        />
                    </Grid>
                    <Grid item xs>
                        <TextField
                            style={{width: 400}}
                            label="InviterDateOfBirth (YYYY-MM-DD) (Required)"
                            variant="outlined"
                            value={this.state.inviterDateOfBirth}
                            onChange={this.handleInviterDateOfBirth}
                        />
                    </Grid>

                    <Grid item xs>
                        <Button variant="outlined" color="default" onClick={this.handleSubmit}>
                            Submit
                        </Button>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    {this.state.formSubmitted && <LoadingSpinner/>}
                    {this.state.resultSuccessful &&
                        <AcceptCarePartnerInvitationResult resultSuccessful={this.state.resultSuccessful} response={this.state.response}/>}
                </Grid>

                { this.state.errorMessage &&
                    <div>
                        <br/>
                        <h4>Encountered an Error</h4>
                        <p style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <Alert variant="filled" severity="info">
                                { this.state.errorMessage }
                            </Alert>
                        </p>
                    </div>
                }

                { this.state.response &&
                    <div>
                        <br/>
                        <h4>Accept Care Partner Invitation Response</h4>
                        <p style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <JsonRenderComponent jsonObject={ this.state.response } printHtml={ false }/>
                        </p>
                    </div>
                }
            </Grid>
        );
    }

    public handleClose() {
        this.setState({open: false})
    }

    public handleInviteePersonId(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({inviteePersonId: event.target.value})
    }

    public handleInviteeCID(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({inviteeCID: event.target.value})
    }

    public handleInvitationId(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({invitationId: event.target.value})
    }

    public handleInviterDateOfBirth(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({inviterDateOfBirth: event.target.value})
    }

    private handleSubmit() {
        // Set initial state for form submission and reset previous messages
        this.setState({
            errorMessage: null,
            formSubmitted: true,
            resultSuccessful: false,
        });

        const apiName = 'ApaqPortalAPI';
        const path = '/pharmacy-customer/update/accept-care-partner-invitation';
        const config = {
            body: {
                inviteePersonId: this.state.inviteePersonId,
                inviteeCID: this.state.inviteeCID,
                invitationId: this.state.invitationId,
                inviterDateOfBirth: this.state.inviterDateOfBirth,
            },
            headers: {}
        };

        API.post(apiName, path, config)
            .then((response: any) => {
                console.log(response);
                this.setState({
                    formSubmitted: false,
                    response,
                });
            })
            .catch((error) => {
                console.error(error);
                alert(error);
                this.setState({
                    errorMessage: error.response?.errorMessage,
                    formSubmitted: false
                });
            });
    }

}

export default withStyles(styles)(AcceptCarePartnerInvitationSection);
